import axios from "axios"

export const get = (licenceId) => {
  return axios.get(`/api/licence/get?licenceId=${licenceId}`).then((response) => {
    return response.data
  })
}

export const getAll = () => {
  return axios.get(`/api/licence/getAll`).then((response) => {
    return response.data
  })
}

export const getAllSummary = () => {
  return axios.get(`/api/licence/getAllSummary`).then((response) => {
    return response.data
  })
}

export const getAllDongleLicences = () => {
  return axios.get(`/api/licence/getAllDongleLicences`).then((response) => {
    return response.data
  })
}

export const getLicencesForCustomer = (customerId) => {
  return axios.get(`/api/licence/getLicencesForCustomer?customerId=${customerId}`).then((response) => {
    return response.data
  })
}

export const getHistory = (licenceId) => {
  return axios.get(`/api/licence/getHistory?licenceId=${licenceId}`).then((response) => {
    return response.data
  })
}

export const getLastInfo = (licenceId) => {
  return axios.get(`/api/licence/getLastInfo?licenceId=${licenceId}`).then((response) => {
    return response.data
  })
}

export const generate = (licenceData) => {
  return axios
    .post(`/api/licence/glic`, {
      data: licenceData
    })
    .then((response) => {
      return response.data
    })
}

export const sendLicenceEmail = (keyId) => {
  return axios.post(`/api/licence/sendLicenceEmail`, {
    data: keyId
  })
}

export const deleteLicence = (licence) => {
  return axios.post(`/api/licence/delete`, {
    data: licence
  })
}
